import {
    ApiInvokerService, ConfigurationService, environment
} from 'projects/mypay4-fe-common/src/public-api';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { Comune, Nazione, Provincia } from '../model/location';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private baseApiUrl: string;

  constructor(
    private apiInvokerService: ApiInvokerService,
    conf: ConfigurationService
  ) {
    this.baseApiUrl = conf.getProperty('baseApiUrl', environment);
  }

  //cache values
  private nazioni: Nazione[];
  private province: Provincia[];
  private comuni: Comune[][]=[];

  getNazioni(): Observable<Nazione[]> {
    return this.nazioni ? of(this.nazioni) :
      this.apiInvokerService.get<Nazione[]>(this.baseApiUrl + 'public/location/nazioni')
        .pipe(tap(nazioni => this.nazioni=nazioni ));
  }

  getProvince(): Observable<Provincia[]> {
    return this.province ? of(this.province) :
      this.apiInvokerService.get<Provincia[]>(this.baseApiUrl + 'public/location/province')
        .pipe(tap(province => this.province=province ));
  }

  getComuni(provincia: Provincia): Observable<Comune[]> {
    return this.comuni[provincia.provinciaId] ? of(this.comuni[provincia.provinciaId]) :
      this.apiInvokerService.get<Comune[]>(this.baseApiUrl + 'public/location/comuni/' + provincia.provinciaId)
        .pipe(tap(comuni => this.comuni[provincia.provinciaId]=comuni ));
  }
}
